/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAudience } from '../models/work-audience';
import { WorkContact } from '../models/work-contact';
import { WorkCreateAudienceDto } from '../models/work-create-audience-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkManageContactsDto } from '../models/work-manage-contacts-dto';
import { WorkManageUsersDto } from '../models/work-manage-users-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateAudienceDto } from '../models/work-update-audience-dto';
import { WorkUser } from '../models/work-user';

@Injectable({ providedIn: 'root' })
export class WorkAudiencesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `audiencesV2ControllerGetAllDropdownOptions()` */
  static readonly AudiencesV2ControllerGetAllDropdownOptionsPath = '/v2/audiences/dropdown-options';

  /**
   * Required permissions: audiences:read, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: audiences:read, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.audiencesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `audiencesV2ControllerFindAllPaginated()` */
  static readonly AudiencesV2ControllerFindAllPaginatedPath = '/v2/audiences/paginated';

  /**
   * Required permissions: audiences:read, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>description</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'description:ASC' | 'description:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,description
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>description</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkAudience>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkAudience>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: audiences:read, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>description</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'description:ASC' | 'description:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,description
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>description</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkAudience>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}> {
    return this.audiencesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkAudience>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkAudience>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
} => r.body)
    );
  }

  /** Path part for operation `audiencesV2ControllerFindAll()` */
  static readonly AudiencesV2ControllerFindAllPath = '/v2/audiences';

  /**
   * Required permissions: audiences:read, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAudience>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAudience>>;
      })
    );
  }

  /**
   * Required permissions: audiences:read, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkAudience>> {
    return this.audiencesV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAudience>>): Array<WorkAudience> => r.body)
    );
  }

  /** Path part for operation `audiencesV2ControllerCreate()` */
  static readonly AudiencesV2ControllerCreatePath = '/v2/audiences';

  /**
   * Required permissions: audiences:create, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  audiencesV2ControllerCreate$Response(
    params: {
      body: WorkCreateAudienceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAudience>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAudience>;
      })
    );
  }

  /**
   * Required permissions: audiences:create, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  audiencesV2ControllerCreate(
    params: {
      body: WorkCreateAudienceDto
    },
    context?: HttpContext
  ): Observable<WorkAudience> {
    return this.audiencesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAudience>): WorkAudience => r.body)
    );
  }

  /** Path part for operation `audiencesV2ControllerFindOne()` */
  static readonly AudiencesV2ControllerFindOnePath = '/v2/audiences/{id}';

  /**
   * Required permissions: audiences:read, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerFindOne$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAudience>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAudience>;
      })
    );
  }

  /**
   * Required permissions: audiences:read, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerFindOne(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkAudience> {
    return this.audiencesV2ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAudience>): WorkAudience => r.body)
    );
  }

  /** Path part for operation `audiencesV2ControllerDelete()` */
  static readonly AudiencesV2ControllerDeletePath = '/v2/audiences/{id}';

  /**
   * Required permissions: audiences:delete, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: audiences:delete, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.audiencesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `audiencesV2ControllerUpdate()` */
  static readonly AudiencesV2ControllerUpdatePath = '/v2/audiences/{id}';

  /**
   * Required permissions: audiences:update, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  audiencesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateAudienceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAudience>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAudience>;
      })
    );
  }

  /**
   * Required permissions: audiences:update, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  audiencesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateAudienceDto
    },
    context?: HttpContext
  ): Observable<WorkAudience> {
    return this.audiencesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAudience>): WorkAudience => r.body)
    );
  }

  /** Path part for operation `audiencesV2ControllerFindAllUsersForAudiencePaginated()` */
  static readonly AudiencesV2ControllerFindAllUsersForAudiencePaginatedPath = '/v2/audiences/{id}/users';

  /**
   * Required permissions: audiences:read, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerFindAllUsersForAudiencePaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerFindAllUsersForAudiencePaginated$Response(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by audiencesUsers.audienceId query param.
     *           <p>
     *              <b>Format: </b> filter.audiencesUsers.audienceId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.audiencesUsers.audienceId=$not:$like:John Doe&filter.audiencesUsers.audienceId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.audiencesUsers.audienceId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> lastName:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>firstName</li>
     * <li>lastName</li></ul>
     */
      sortBy?: Array<'firstName:ASC' | 'firstName:DESC' | 'lastName:ASC' | 'lastName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> firstName,lastName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>firstName</li>
     * <li>lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkUser>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'audiencesUsers.audienceId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerFindAllUsersForAudiencePaginatedPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.audiencesUsers.audienceId', params['filter.audiencesUsers.audienceId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkUser>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'audiencesUsers.audienceId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: audiences:read, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerFindAllUsersForAudiencePaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerFindAllUsersForAudiencePaginated(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by audiencesUsers.audienceId query param.
     *           <p>
     *              <b>Format: </b> filter.audiencesUsers.audienceId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.audiencesUsers.audienceId=$not:$like:John Doe&filter.audiencesUsers.audienceId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.audiencesUsers.audienceId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> lastName:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>firstName</li>
     * <li>lastName</li></ul>
     */
      sortBy?: Array<'firstName:ASC' | 'firstName:DESC' | 'lastName:ASC' | 'lastName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> firstName,lastName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>firstName</li>
     * <li>lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkUser>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'audiencesUsers.audienceId'?: (string | Array<string>);
};
};
}> {
    return this.audiencesV2ControllerFindAllUsersForAudiencePaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkUser>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'audiencesUsers.audienceId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkUser>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'audiencesUsers.audienceId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `audiencesV2ControllerAddUsers()` */
  static readonly AudiencesV2ControllerAddUsersPath = '/v2/audiences/{id}/users';

  /**
   * Required permissions: audiences:update, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerAddUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  audiencesV2ControllerAddUsers$Response(
    params: {
      id: number;
      body: WorkManageUsersDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAudience>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerAddUsersPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAudience>;
      })
    );
  }

  /**
   * Required permissions: audiences:update, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerAddUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  audiencesV2ControllerAddUsers(
    params: {
      id: number;
      body: WorkManageUsersDto
    },
    context?: HttpContext
  ): Observable<WorkAudience> {
    return this.audiencesV2ControllerAddUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAudience>): WorkAudience => r.body)
    );
  }

  /** Path part for operation `audiencesV2ControllerRemoveUsers()` */
  static readonly AudiencesV2ControllerRemoveUsersPath = '/v2/audiences/{id}/users';

  /**
   * Required permissions: audiences:update, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerRemoveUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  audiencesV2ControllerRemoveUsers$Response(
    params: {
      id: number;
      body: WorkManageUsersDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAudience>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerRemoveUsersPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAudience>;
      })
    );
  }

  /**
   * Required permissions: audiences:update, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerRemoveUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  audiencesV2ControllerRemoveUsers(
    params: {
      id: number;
      body: WorkManageUsersDto
    },
    context?: HttpContext
  ): Observable<WorkAudience> {
    return this.audiencesV2ControllerRemoveUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAudience>): WorkAudience => r.body)
    );
  }

  /** Path part for operation `audiencesV2ControllerFindAllContactsForAudiencePaginated()` */
  static readonly AudiencesV2ControllerFindAllContactsForAudiencePaginatedPath = '/v2/audiences/{id}/contacts';

  /**
   * Required permissions: audiences:read, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerFindAllContactsForAudiencePaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerFindAllContactsForAudiencePaginated$Response(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by audiencesContacts.audienceId query param.
     *           <p>
     *              <b>Format: </b> filter.audiencesContacts.audienceId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.audiencesContacts.audienceId=$not:$like:John Doe&filter.audiencesContacts.audienceId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.audiencesContacts.audienceId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> lastName:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>firstName</li>
     * <li>lastName</li></ul>
     */
      sortBy?: Array<'firstName:ASC' | 'firstName:DESC' | 'lastName:ASC' | 'lastName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> company,firstName,lastName,zipcode,street
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>company</li>
     * <li>firstName</li>
     * <li>lastName</li>
     * <li>zipcode</li>
     * <li>street</li>
     * <li>city</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkContact>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'audiencesContacts.audienceId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerFindAllContactsForAudiencePaginatedPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.audiencesContacts.audienceId', params['filter.audiencesContacts.audienceId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkContact>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'audiencesContacts.audienceId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: audiences:read, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerFindAllContactsForAudiencePaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  audiencesV2ControllerFindAllContactsForAudiencePaginated(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by audiencesContacts.audienceId query param.
     *           <p>
     *              <b>Format: </b> filter.audiencesContacts.audienceId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.audiencesContacts.audienceId=$not:$like:John Doe&filter.audiencesContacts.audienceId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.audiencesContacts.audienceId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> lastName:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>firstName</li>
     * <li>lastName</li></ul>
     */
      sortBy?: Array<'firstName:ASC' | 'firstName:DESC' | 'lastName:ASC' | 'lastName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> company,firstName,lastName,zipcode,street
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>company</li>
     * <li>firstName</li>
     * <li>lastName</li>
     * <li>zipcode</li>
     * <li>street</li>
     * <li>city</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkContact>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'audiencesContacts.audienceId'?: (string | Array<string>);
};
};
}> {
    return this.audiencesV2ControllerFindAllContactsForAudiencePaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkContact>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'audiencesContacts.audienceId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkContact>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'audiencesContacts.audienceId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `audiencesV2ControllerAddContacts()` */
  static readonly AudiencesV2ControllerAddContactsPath = '/v2/audiences/{id}/contacts';

  /**
   * Required permissions: audiences:update, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerAddContacts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  audiencesV2ControllerAddContacts$Response(
    params: {
      id: number;
      body: WorkManageContactsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAudience>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerAddContactsPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAudience>;
      })
    );
  }

  /**
   * Required permissions: audiences:update, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerAddContacts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  audiencesV2ControllerAddContacts(
    params: {
      id: number;
      body: WorkManageContactsDto
    },
    context?: HttpContext
  ): Observable<WorkAudience> {
    return this.audiencesV2ControllerAddContacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAudience>): WorkAudience => r.body)
    );
  }

  /** Path part for operation `audiencesV2ControllerRemoveContacts()` */
  static readonly AudiencesV2ControllerRemoveContactsPath = '/v2/audiences/{id}/contacts';

  /**
   * Required permissions: audiences:update, audiences:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `audiencesV2ControllerRemoveContacts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  audiencesV2ControllerRemoveContacts$Response(
    params: {
      id: number;
      body: WorkManageContactsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAudience>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAudiencesV2Service.AudiencesV2ControllerRemoveContactsPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAudience>;
      })
    );
  }

  /**
   * Required permissions: audiences:update, audiences:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `audiencesV2ControllerRemoveContacts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  audiencesV2ControllerRemoveContacts(
    params: {
      id: number;
      body: WorkManageContactsDto
    },
    context?: HttpContext
  ): Observable<WorkAudience> {
    return this.audiencesV2ControllerRemoveContacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAudience>): WorkAudience => r.body)
    );
  }

}
